<template>
  <div class="-mx-4 flex overflow-x-auto px-4 py-5.5 lg:hidden">
    <ul class="flex space-x-6">
      <li v-if="generalStore.isAuthenticated">
        <nuxt-link
          class="whitespace-nowrap text-white"
          :to="localePath('/profile')"
          active-class="underline underline-offset-2"
        >
          {{ $t("myProfile") }}
        </nuxt-link>
      </li>
      <li>
        <nuxt-link
          class="whitespace-nowrap text-white"
          :to="localePath('/orders')"
          active-class="underline underline-offset-2"
        >
          {{ $t("ordersHistory") }}
        </nuxt-link>
      </li>
      <li v-if="generalStore.isAuthenticated">
        <nuxt-link
          class="whitespace-nowrap text-white"
          :to="localePath('/favorites')"
          active-class="underline underline-offset-2"
        >
          {{ $t("wishlist") }}
        </nuxt-link>
      </li>
      <li v-if="generalStore.isAuthenticated">
        <div class="whitespace-nowrap text-white" @click="onLogout">
          {{ $t("logout") }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
const localePath = useLocalePathPolyfill();
const generalStore = useGeneralStore();
const router = useRouter();
const { logout } = useAuth();

async function onLogout() {
  try {
    await logout();
  } catch (error) {
    console.log(error);
  } finally {
    await Promise.all([generalStore.getCart(), generalStore.getWishList()]);
    await router.replace(localePath("/"));
  }
}
</script>
